module.exports = __webpack_public_path__ + "2b70f3e29a31078e2833b96b2a12b7aa.webp";